// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ecJN","actions":"styles_actions__2vRcr","error":"styles_error__7hEGz","message":"styles_message__1MPUX"};